import React, { useEffect, useState } from 'react';

import cx from 'classnames';
import _ from 'lodash';

import { Pagination } from './pagination';

import styles from '../report.module.scss';

export function TableFooter({ pagination, currentChart, disableView, handlePageChange, handleChartChange, leftAlign, paginationName }) {
  const viewPorts = [{ type: "table_view", icon: <i className={cx('cleverstory-table', styles.tableIcons)}/>}, { type: "graph_view", icon: <i className={cx('cleverstory-graph', styles.tableIcons)}/>}, { type: "pie_chart_view", icon: <i className={cx('cleverstory-pie_chart', styles.tableIcons)}/>},];

  return (
    <div className={cx(styles.tableActions, { [styles.mg_0]: leftAlign })}>
      {pagination && currentChart == "table_view" &&
        <Pagination
          pagination={pagination}
          currentChart={currentChart}
          type={paginationName}
          onClick={handlePageChange} />
      }

      <div className={styles.viewPortContainer}>
        {viewPorts.filter(item => !disableView.includes(item.type)).map((viewport, index) => {
          return (
            <div key={index} className={cx(styles.viewPort, { [styles.active]: (currentChart === viewport.type) })} onClick={() => handleChartChange(viewport.type)}>
              {viewport.icon}
            </div>
          )
        })}
      </div> 
    </div>
  )
}